import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useRecommendationsDashboard } from '/@/hooks/dashboards';
import { useOwnUserNode } from '/@/hooks/nodes';
import { useCurrentCampaignYear } from '/@/hooks/zones';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import DashboardSubheader from '/@/views/dashboard/components/dashboard-sub-header';
import RecommendationList from '/@/views/dashboard/components/recommendations-list';
import { RecommendationsDashboardCards } from '/@/views/dashboard/components/recommendations-tab-cards';

const GrowerDashboardCurrentCampaign = ({ growerNodeId }: { growerNodeId: number }) => {
    const currentCampaignYear = useCurrentCampaignYear();
    const form = useForm<{
        year: number;
    }>({
        defaultValues: {
            year: currentCampaignYear ?? new Date().getFullYear(),
        },
    });

    // Update form value when currentCampaignYear becomes available
    useEffect(() => {
        if (currentCampaignYear !== null) {
            form.setValue('year', currentCampaignYear);
        }
    }, [currentCampaignYear, form]);

    const year = form.watch('year');
    const { data: hybridRecommendations, isValidating: isValidatingHybrid } = useRecommendationsDashboard({
        year,
        type_in: ['corn', 'soy', 'density'],
        node: growerNodeId,
        ...getNodeScopeFilters('myFields'),
    });
    const { data: cropProtectionRecommendations, isValidating: isValidatingCropProtection } =
        useRecommendationsDashboard({
            year,
            type_in: ['disease', 'plague', 'weed', 'seed_treatment'],
            node: growerNodeId,
            ...getNodeScopeFilters('myFields'),
        });

    const isValidating = isValidatingHybrid || isValidatingCropProtection;
    const ownUserNodeQuery = useOwnUserNode();
    const isOwnUserNode = ownUserNodeQuery.data?.id === growerNodeId;
    return (
        <>
            <Stack direction='column' spacing={3}>
                <DashboardSubheader
                    title={_('Recomendaciones')}
                    subtitle={
                        isOwnUserNode
                            ? _('Consultá las recomendaciones generadas para tus lotes durante la campaña.')
                            : _(
                                  'Consultá las recomendaciones generadas para los lotes de el productor durante la campaña.'
                              )
                    }
                    form={form}
                />
                <RecommendationsDashboardCards
                    hybridRecommendations={hybridRecommendations}
                    cropProtectionRecommendations={cropProtectionRecommendations}
                    isValidating={isValidating}
                />
            </Stack>

            <RecommendationList userNodeId={growerNodeId} year={year} nodeScope={getNodeScopeFilters('myFields')} />
        </>
    );
};

export default GrowerDashboardCurrentCampaign;
